import React from "react";
import { Link } from "react-router-dom";

export default () => {
  return (
    <div>
      <div className="site-content h-100">
        <div className="p-4">
          <div className="site-content-body">
            <div className="container gx-0">
              <div className="row">
                <div className="col">
                  <div>
                    <div className="d-md-flex flex-wrap justify-content-between main_bg_color pt-2 px-4">
                      <div className="d-md-flex gap-2 my-2">
                        <div className="d-flex pe-1 search_All_border rounded-pill mb-sm-0 mb-2">
                          <button className="bi-search searchbtn ps-4" />
                          <input
                            placeholder="search"
                            className="form-control search_input_width rounded-pill border-0 bi-search"
                          />
                        </div>
                        <div className="dropdown d-flex justify-content-center justify-content-sm-start mt-2 mt-md-0">
                          <button
                            type="button"
                            className="btn bg-white rounded-pill d-flex sort_border px-4 mb-sm-0 mb-2"
                            data-bs-toggle="dropdown"
                          >
                            Sort{" "}
                            <i className="bi bi-filter-left my-auto ms-1 text-primary" />
                          </button>
                          <ul
                            className="dropdown-menu ps-3 text-primary fw-bold"
                            style={{ backgroundColor: "#EDEDED" }}
                          >
                            <li className="mb-3">Sort Data</li>
                            <li className="mb-3">End Data</li>
                            <li className="mb-3">Sort A-Z</li>
                            <li className="mb-3">Sort Z-A</li>
                          </ul>
                        </div>
                      </div>
                      <div className="swich_button mt-md-0 mt-sm-3 mt-2 my-2">
                        <ul
                          className="nav rounded-pill tabs_posetion"
                          id="myTab"
                        >
                          <li>
                            {/* remove form Active Buttontext-white active tab_active */}
                            <button
                              className=" btn btn_active rounded-pill fw-bold px-4 active"
                              id="home-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#home"
                              type="button"
                            >
                              ACTIVE
                            </button>
                          </li>
                          <li>
                            <button
                              className=" btn btn_active rounded-pill fw-bold px-4"
                              id="profile-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#profile"
                              type="button"
                              role="tab"
                              aria-controls="profile"
                              aria-selected="false"
                            >
                              INACTIVE
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="home"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                      >
                        <div className="main_bg_color h-100">
                          <div className="container-fluid">
                            <div className="row py-3">
                              <div className="col-lg-4 col-md-12 px-4 mb-5 d-flex gap-4 align-items-center ">
                                <div>
                                  <div className="card card_border_1">
                                    <div
                                      className="div_background_color_1 py-4"
                                      style={{ height: "200px" }}
                                    >
                                      <h2 className=" pb-3">
                                        Request
                                        <br />
                                        New
                                        <br /> Campaigns!
                                      </h2>
                                      <p>
                                        Click below to submit campaign request
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mt-2">
                                    <button className="btn bg_button_color text-white py-2 w-100 fs_14px ">
                                      Create Request
                                    </button>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    borderRight: "7px solid #868B8F",
                                    height: 120,
                                  }}
                                ></div>
                              </div>
                              <div className=" col-lg-4 col-md-12 px-4 mb-5">
                                <Link to={"/advertiserViewCampaign"}>
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_nike.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "171px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          NIKE
                                        </button>
                                      </div>
                                      {/* <div className="nike_chat_icon">
                                        <i className="bi bi-chat-left-fill fa-2x" />
                                      </div> */}
                                      <div className="text-black job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>01/08/2023</span>
                                        </p>
                                        <p>
                                          End Date:
                                          <span>05/20/2023</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_adidas.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "171px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        ADIDAS
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="mb-2">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p>
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_waty.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "171px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        DISNEY
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="mb-2">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p>
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_hulu.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "171px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        HULU
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="mb-2">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p>
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_netflex.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "171px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        NETFLIX
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="mb-2">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p>
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="profile"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <div className="main_bg_color h-100">
                          <div className="container-fluid">
                            <div className="row py-3">
                              <div className="col-lg-4 col-md-12 px-4 mb-5 d-flex gap-4 align-items-center ">
                                <div>
                                  <div className="card card_border_1">
                                    <div
                                      className="div_background_color_1 py-4"
                                      style={{ height: "200px" }}
                                    >
                                      <h2 className=" pb-3">
                                        Request
                                        <br />
                                        New
                                        <br /> Campaigns!
                                      </h2>
                                      <p>
                                        Click below to submit campaign request
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mt-2">
                                    <button className="btn bg_button_color text-white py-2 w-100 fs_14px">
                                      Create Request
                                    </button>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    borderRight: "7px solid #868B8F",
                                    height: 120,
                                  }}
                                ></div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a href="#">
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_nike.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          NIKE
                                        </button>
                                      </div>
                                      {/* <div className="nike_chat_icon">
                                        <i className="bi bi-chat-left-fill fa-2x" />
                                      </div> */}
                                      <div className="card-body job_bg text-dark py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a href="#">
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_adidas.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          ADIDAS
                                        </button>
                                      </div>
                                      <div className="card-body job_bg  text-dark py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a href="#">
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_waty.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          DISNEY
                                        </button>
                                      </div>
                                      <div className="card-body job_bg text-dark py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a href="./jobs_just_do_it.html">
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_hulu.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          HULU
                                        </button>
                                      </div>
                                      <div className="card-body job_bg text-dark py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a href="./jobs_just_do_it.html">
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_netflex.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          NETFLEX
                                        </button>
                                      </div>
                                      <div className="card-body job_bg text-dark py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
